import isEmptyArray from './isEmptyArray';
import isEmptyObject from './isEmptyObject';

// ----------------------------------------------------------------------------

function isEmpty(value: unknown): boolean {
    if (value == null) {
        return true;
    }
    if (typeof value === 'string') {
        return value.trim().length === 0;
    }
    if (Array.isArray(value)) {
        return isEmptyArray(value);
    }
    if (typeof value === 'object') {
        return isEmptyObject(value);
    }
    return false;
}

// ----------------------------------------------------------------------------

export default isEmpty;
